import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.s5g().x51() : headers;
  return DelegatedCall().o5i(_this__u8e3s4.n5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.o5i(client, originCall, responseContent, responseHeaders);
      }
      static o5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.s5g().x51() : responseHeaders;
        var $this = this.p5i(client);
        $this.p5g_1 = new (DelegatedRequest())($this, originCall.q5i());
        $this.q5g_1 = new (DelegatedResponse())($this, originCall.s5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.v5i_1 = origin;
        this.w5i_1 = call;
      }
      x5i() {
        return this.w5i_1;
      }
      bw() {
        return this.v5i_1.bw();
      }
      y5i() {
        return this.v5i_1.y5i();
      }
      z5i() {
        return this.v5i_1.z5i();
      }
      r5i() {
        return this.v5i_1.r5i();
      }
      z2n() {
        return this.v5i_1.z2n();
      }
      x51() {
        return this.v5i_1.x51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.x51() : headers;
        super();
        this.a5j_1 = call;
        this.b5j_1 = origin;
        this.c5j_1 = content;
        this.d5j_1 = headers;
        this.e5j_1 = this.b5j_1.bw();
      }
      x5i() {
        return this.a5j_1;
      }
      x51() {
        return this.d5j_1;
      }
      f5j() {
        return this.c5j_1(this.b5j_1);
      }
      bw() {
        return this.e5j_1;
      }
      g5j() {
        return this.b5j_1.g5j();
      }
      h5j() {
        return this.b5j_1.h5j();
      }
      i5j() {
        return this.b5j_1.i5j();
      }
      j5j() {
        return this.b5j_1.j5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
